import { Dropdown } from '@single-platform/components';
import styled from 'styled-components';

export const DropdownStyled = styled(Dropdown)`
  margin-bottom: 0.5rem;
`;
